import { render, staticRenderFns } from "./HeaderItem.vue?vue&type=template&id=4275854c&"
import script from "./HeaderItem.vue?vue&type=script&lang=js&"
export * from "./HeaderItem.vue?vue&type=script&lang=js&"
import style0 from "./HeaderItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4275854c')) {
      api.createRecord('4275854c', component.options)
    } else {
      api.reload('4275854c', component.options)
    }
    module.hot.accept("./HeaderItem.vue?vue&type=template&id=4275854c&", function () {
      api.rerender('4275854c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/hotsugg/components/HeaderItem.vue"
export default component.exports